export default "__VITE_ASSET__CYA37Xcq__"